export function stars(level: string) {
  return {good: [1], better: [1, 2], best: [1, 2, 3]}[level];
}

export function background(level: string) {
  return {good: 'bg-bronze', better: 'bg-zinc-300', best: 'bg-amber-400'}[level];
}

export function containerClasses(level: string) {
  const variantClasses: any = {good: 'border-bronze', better: 'border-zinc-300', best: 'border-amber-400'};
  return `w-full h-full border-1 rounded ${variantClasses[level]}`;
}
